import { Input } from "antd";
import { AiOutlinePhone } from "react-icons/ai";
import styled from "styled-components";
import { AppPartType } from "../../../types";
import { FC } from "react";

const Styles = styled.div`
  display: flex;
  .branch-icon {
    display: flex;
    align-items: center;
    background: #174a83;
    padding: 0 5px;
    border: 0.5px solid #f7f9fa;
    border-radius: 3px;
  }
  .ant-input-wrapper,
  .ant-btn-icon-only,
  .ant-input-wrapper {
    height: 100%;
  }
  input {
    height: 100%;
  }
`;

type PropsType = {
  appPart: AppPartType;
};
const CompanyPhoneNumberSelection: FC<PropsType> = ({ appPart }) => {
  return (
    <Styles style={{ height: "100%", maxHeight: "42px" }}>
      <Input.Search disabled />
      <div className="branch-icon">
        <AiOutlinePhone size={20} color="#fff" />
      </div>
    </Styles>
  );
};

export default CompanyPhoneNumberSelection;
